export default __webpack_public_path__ + "static/background-mobile-c93dcdc0345d640061e3070b2fd6841d.jpg";